export class NavBar {

  constructor() {
    this.resizeDebouncer = null;
    this.win = $(window);
    this.body = $('body');
    this.navbar = $('.main-nav');
    this.dropdowns = $('.main-nav .dropdown');
    this.dropdownLinks = $('.main-nav .dropdown > a');
    this.dropdownMenus = $('.main-nav .dropdown-menu');
    this.dropdownMenuLinks = $('.main-nav .dropdown-menu a');

    this.watchNavbar();
    this.handleTouchEvents();
  }

  watchNavbar() {

    this.win.on('resize orientationchange', e => {
      clearTimeout(this.resizeDebouncer);
      this.resizeDebouncer = setTimeout(() => {
        this.handleTouchEvents();
      }, 250);
    });

  }

  handleTouchEvents() {

    if (this.win.innerWidth() >= 768) {
      this.dropdownLinks.on('touchstart.touchEvents touchend.touchEvents', e => {
        e.preventDefault();
        e.stopPropagation();
        this.dropdowns.removeClass('touched');
        $(e.currentTarget).parent('.dropdown').addClass('touched');
      });

      this.body.on('touchend.touchEvents', e => {
        this.dropdowns.removeClass('touched');
      });

      this.dropdownMenuLinks.on('touchend.touchEvents', e => {
        e.stopPropagation();
      });
    } else {
      this.dropdownLinks.unbind('.touchEvents');
      this.body.unbind('.touchEvents');
      this.dropdownMenuLinks.unbind('.touchEvents');
    }

  }

};
